export const NameValidation = [{ required: true, message: "Name is required" }];

export const EmailValidation = [
  { required: true, message: "Email is required" },
  { type: "email", message: "Email is invalid" },
  { max: 30, message: "Email must have maximum of 30 letters" },
  { min: 2, message: "Email must have minimum of 2 letters" },
];
